// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hide-sort-icon[data-v-2963f7e8] .v-data-table-header__icon,.no-sort-column[data-v-2963f7e8] .v-data-table-header__icon{display:none!important}", ""]);
// Exports
module.exports = exports;
